import http from "@/common/http.service";
const ROOT_URL = "user/list";
const DELETE_URL = "user/delete";
const RESEND_URL = "user/resend-invitation";
const USER_SAVE = "user/save";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = { items: response.data.data, total: response.data.totalRows };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL, { id: id });
  },
};

export const saveUser = (params) => {
  return http.post(USER_SAVE, params);
};

export const resendInvitation = (id) => {
  return http.post(RESEND_URL, { id: id });
};
